export default [
    "#F44336",
    "#E91E63",
    "#9C27B0",
    "#673AB7",
    "#311B92",
    "#3F51B5",
    "#2196F3",
    "#03A9F4",
    "#00E5FF",
    "#00BCD4",
    "#009688",
    "#4CAF50",
    "#8BC34A",
    "#CDDC39",
    "#FFEB3B",
    "#FFC107",
    "#FF9800",
    "#FF5722",
    "#795548",
    "#607D8B",
    "#9E9E9E",
    "#FFFFFF",
    "#000000",
    "rgba(0,0,0,0)"
]
